import { FC } from "react";
import { createStyles, Input, InputProps, makeStyles } from "@material-ui/core";

import { colors } from "theme/constants";

export type InputExtraOwnProps = {
  warning?: boolean;
};

export type InputExtraProps = InputProps & InputExtraOwnProps;

const useInputExtraStyles = makeStyles(() =>
  createStyles({
    warning: {
      "&::after": {
        borderBottomColor: `${colors.warning} !important`,
      },
    },
  }),
);

export const InputExtra: FC<InputExtraProps> = ({
  warning,
  error,
  className,
  ...props
}) => {
  const { warning: warningClassname } = useInputExtraStyles();
  let customClassName: string | undefined;
  if (!error && warning) {
    error = true;
    customClassName = warningClassname;
  }
  return (
    <Input
      className={`${customClassName ?? ""} ${className}`}
      error={error}
      {...props}
    />
  );
};
